<ng-container *ngIf="props.label$ | async as label">
  <div
    *ngIf="label.msg"
    class="label-container"
    [style.marginBottom]="label.offset"
  >
    <label
      class="label"
      [htmlFor]="id"
      [style.fontWeight]="label.weight"
      [style.fontSize]="label.size"
      [style.color]="label.isFake ? 'transparent' : null"
    >
      <span [class.label_required]="props.required">{{ label.msg }}</span>

      <ng-container
        *ngIf="(props.hintPlace$ | async) === 'label'"
        [ngTemplateOutlet]="hintElement"
      ></ng-container>

      <ng-container
        *ngIf="(props.tagPlace$ | async) === 'label'"
        [ngTemplateOutlet]="tagElement"
      ></ng-container>
    </label>
  </div>
</ng-container>

<div
  class="field-container"
  [class.field-container_input-like]="
    (props.fieldDisplayMode$ | async) === 'input-like'
  "
>
  <div [class.field_full-width]="props.isFullWidth">
    <ng-container #fieldComponent></ng-container>
  </div>

  <ng-container
    *ngIf="(props.hintPlace$ | async) === 'field'"
    [ngTemplateOutlet]="hintElement"
  ></ng-container>

  <ng-container
    *ngIf="(props.tagPlace$ | async) === 'field'"
    [ngTemplateOutlet]="tagElement"
  ></ng-container>
</div>

<div class="footer-container">
  <isp-field-description
    *ngIf="props.fieldDesc$ | async as desc"
    [desc]="desc"
  ></isp-field-description>

  <isp-field-plain-hint
    *ngIf="props.fieldPlainHintMsg$ | async as plainHintMsg"
    [plainHintMsg]="plainHintMsg"
  ></isp-field-plain-hint>

  <isp-field-buttons
    *ngIf="props.fieldButtons$ | async as buttons"
    [buttons]="buttons"
  ></isp-field-buttons>
</div>

<ng-template #hintElement>
  <isp-field-hint
    *ngIf="props.hint$ | async as hintMsg"
    class="hint"
    [hintMsg]="hintMsg"
    [hintAttachContainer]="hintAttachContainer"
    [visible]="!(isErrorDisplayed$ | async)"
  ></isp-field-hint>
</ng-template>

<ng-template #tagElement>
  <isp-field-tag
    *ngIf="props.tagData$ | async as tagData"
    class="tag"
    [tagData]="tagData"
    [hintAttachContainer]="hintAttachContainer"
  ></isp-field-tag>
</ng-template>
